import strapiPreviewConfig from 'constants/strapi';

export default function isDraft({
  slug,
  queryParams,
}: {
  slug: string;
  queryParams: URLSearchParams;
}) {
  return slug === strapiPreviewConfig.draftRoute || queryParams.get('draft') === 'true';
}
